import { SeamlessRegistrationProviderType } from "./seamless-registration.model";

export const SEAMLESS_REGISTRATION_MESSAGE_CODE = {
	error: {
		unknown: "E_SEAMLESSREGISTRATION",
		notFound: "E_SEAMLESSREGISTRATION_NOTFOUND",
		emailInvalid: "E_VALIDATION",
	},
};

export const SEAMLESS_REGISTRATION_PROVIDER_TYPE = {
	trustly: "trustly" as SeamlessRegistrationProviderType,
};
